/** Keep in sync with portal-backend VALID_PAGE_BG_DIRECTIONS. */
export const PAGE_BACKGROUND_DIRECTIONS = [
  { id: "to bottom", label: "Top to bottom" },
  { id: "to top", label: "Bottom to top" },
  { id: "to right", label: "Left to right" },
  { id: "to left", label: "Right to left" },
  { id: "to bottom right", label: "Diagonal ↘" },
  { id: "to bottom left", label: "Diagonal ↙" },
  { id: "to top right", label: "Diagonal ↗" },
  { id: "to top left", label: "Diagonal ↖" },
]

export const DEFAULT_PAGE_BACKGROUND = {
  colorStart: "#F3E8FF",
  colorEnd: "#F3E8FF",
  direction: "to bottom",
}

/** Build CSS background — solid when colors match, gradient otherwise. */
export const resolvePageBackgroundCss = (pageBackground, fallbackColor = "#F7FAFC") => {
  const colorStart = pageBackground?.colorStart || fallbackColor
  const colorEnd = pageBackground?.colorEnd || colorStart
  const direction = pageBackground?.direction || "to bottom"

  if (String(colorStart).toLowerCase() === String(colorEnd).toLowerCase()) {
    return colorStart
  }

  return `linear-gradient(${direction}, ${colorStart}, ${colorEnd})`
}
